import React, { useState, useEffect, useRef } from "react";
import { joinRoom, stopSession, leaveSession } from "../libs/kurento";
import NavStruct from "../components/NavStruct";
import { socket, host, loadRTCConfiguration } from "../libs/webRTC";
import AlertError from "../components/Alert";
import fronLogger from "../libs/logger";
import { Typography, Box, Button, LinearProgress, Alert } from "@mui/material";
import Bowser from "bowser";
import axios from "../libs/httpClient";
import { apiFetch } from '../libs/httpClient';
import { useParams } from 'react-router-dom';
import { formatSessionDate, formatElapsedTime } from '../libs/sessionTime';
import { bindRecordingPageLifecycle } from '../libs/recordingPageLifecycle';
import addNotification from "react-push-notification";
import "../i18n";
import { useTranslation } from "react-i18next";
import { useUser } from "../context/UserContext"
import VideoUploadForm from "../components/VideoUploadForm"

const START = "not started";
const IN_PROGRESS = "in progress";
const FINISH = "finished";
const PREVIEW_DURATION = 60;


export default function Client(props) {
	const userContext = useUser();
	const [recordButton, setButtonName] = useState("Начать запись");
	const [colorButton, setColorButton] = useState("success");
	const [disabledButton, setDisableButton] = useState(false);
	const [readyState, setReadyState] = useState(START);
	const [alertText, setAlertText] = useState(
		'Загрузка данных о сессии...'
	);
	const [noStartMsg, setNoStartMsg] = useState(false);
	const [showError, setError] = useState(false);
	const [teacherText, setTeacterText] = useState("");
	const { token } = useParams();
	let sBrowser,
		sUsrAg = navigator.userAgent;
  
  	const startTimeRef = useRef(0);
	const serverStartTimeRef = useRef(0);
	const tempTimeRef = useRef(0);
	const [nowTime, setNowTime] = useState('00:00:00');
	const [sessionData, setSessionData] = useState(null);

	const [screenVideoFile, setScreenVideoFile] = useState(null);
	const [cameraVideoFile, setCameraVideoFile] = useState(null);
	const [screenButtonText, setScreenButtonText] = useState("Выбрать видео экрана");
	const [cameraButtonText, setCameraButtonText] = useState("Выбрать видео камеры");
	const [isUploading, setIsUploading] = useState(false);
	const [uploadProgress, setUploadProgress] = useState(0);
	const [uploadProgressIndeterminate, setUploadProgressIndeterminate] = useState(false);
	const [showPlayer, setShowPlayer] = useState(false);
	const [showUploadForm, setShowUploadForm] = useState(true);
	const [commentText, setCommentText] = useState("");
	const [noCameraVideo, setNoCameraVideo] = useState(false);
	const [uploadSuccess, setUploadSuccess] = useState(false);
	const [uploadMessage, setUploadMessage] = useState("");
	const [formButtonsDisabled, setFormButtonsDisabled] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);
	const [processingTimeLeft, setProcessingTimeLeft] = useState(60);
  
	const intervalRef = useRef(null);
	const previewNodesRef = useRef([]);
	const previewTimersRef = useRef([]);
	const mountedRef = useRef(true);
	const recordingAttemptRef = useRef(0);
	const recordingRef = useRef(false);
	useEffect(() => {
		const started = data => {
			if (data.token !== token) return;
			const timestamp = Date.parse(data.startedAt);
			serverStartTimeRef.current = Number.isFinite(timestamp) ? timestamp : 0;
			setReadyState(IN_PROGRESS);
			setStateProgress('shureDevice');
		};
		const failed = () => setError(true);
		socket.on('recording started', started);
		socket.on('session error', failed);
		return () => {
			socket.off('recording started', started);
			socket.off('session error', failed);
		};
	}, [token]);
	const [t, i18n] = useTranslation();
	const [stateProgress, setStateProgress] = useState("start");
	const [progress, setProgress] = useState(0);
	// const prev_message = useRef("");
	const [prev_message, set_prev_message] = useState(
		`После начала записи экрана в течении ${PREVIEW_DURATION} секунд появится предпоказ видео с экрана и веб камеры`
	);

	useEffect(() => {
		if (sUsrAg.indexOf("Chrome") > -1) return;
		alert("Поменяйте браузер на Chrome или Chromium, в ином случае у вас не получится пройти экзамен");
		fronLogger(token, "Поменяйте браузер на Chrome или Chromium, в ином случае у вас не получится пройти экзамен", "warning", "Client.js");
		setDisableButton(true);
	}, [token, sUsrAg]);

	useEffect(() => {
		const onMessage = (data) => console.log("Frontend client message:", data);
		const onConnectError = (err) => {
			console.error(err.message);
			alert("Проблема с интернет-соединением. Текущий сеанс или запись были прерваны. Создайте новую сессию и начните заново.");
			socket.emit(`close kurento connection (Client.js) on error ${err}`);
		};
		socket.on("send message", onMessage);
		socket.on("connect_error", onConnectError);
		return () => {
			socket.off("send message", onMessage);
			socket.off("connect_error", onConnectError);
		};
	}, []);

	useEffect(() => {
		mountedRef.current = true;
		return () => {
		mountedRef.current = false;
		recordingAttemptRef.current++;
		clearInterval(tempTimeRef.current);
		previewTimersRef.current.forEach((timer) => clearTimeout(timer));
		previewNodesRef.current.forEach((node) => node.remove());
		if (recordingRef.current) {
			stopSession(token).catch(error => fronLogger(token, error.message, 'error', 'Client.js'));
			recordingRef.current = false;
		}
		};
	}, []);

	useEffect(() => {
		axios.get(`${host}/studentData/session/${token}`)
			.then(res => {
				setSessionData(res.data);
				console.log(res.data)
				if (res.data.isUploaded == "Да") {
					setUploadSuccess(true);
					setUploadMessage("Видео уже загружены. Повторная загрузка невозможна.");
					// Don't show player immediately if processing is active
					if (!isProcessing) {
						setShowPlayer(true);
					}
				}
			})
			.catch(err => {
				console.log('err in session data', err);
				fronLogger(token, err, "error", "Watch.js");
			});
	}, []);

	useEffect(()=>{
		if (!sessionData) return;
		if (sessionData['pressedStartButton'] == "Нет")
			setStateProgress("newSession");
		else 
			setStateProgress("oldSession")
	}, [sessionData])

	useEffect(() => {
		switch (stateProgress) {
			case "oldSession":
				setAlertText('Сессия была записана ранее');
				setDisableButton(true);
				setNoStartMsg(true);
				setShowUploadForm(false)
				setShowPlayer(true);
				break;
			case "newSession":
				setAlertText('Шаг 1: Для начала экзамена нажмите кнопку "Начать запись"');
				setDisableButton(false);
				break;
			case "shureStart":
				setProgress(33);
				setAlertText("Шаг 2: Подождите, идет установка соединения...");
				setShowUploadForm(false)
				setFormButtonsDisabled(true);
				setDisableButton(false);
				break;
			case "waitComplete":
				setProgress(66);
				setAlertText(
					"Шаг 3: Разрешение записи камеры и микрофона и демонстрации экрана"
				);
				break;
			// в строке ниже менять описание 4 шага
			case "shureDevice":
				setProgress(100);
				setAlertText(
					'Шаг 4: Следуйте указаниям из блока "Состояние предпоказа"'
				);
				set_start_time();
				document.querySelector("link[rel='icon']").href = "/session_logo.png";
				console.log("Вызвали add_prev_window");
				add_prev_window();
				break;
			case "complete":
				setProgress(100);
				setAlertText("Экзамен успешно завершён!");
				break;
			case "startUploadingVideo":
				setAlertText("Начата загрузка видео");
				break;
			case "videoUploadingCompleted":
				setAlertText("Видео успешно загружены");
				break;
		}
	}, [stateProgress]);

	useEffect(() => {
		axios.get(`${host}/service/room/message/${token}`).then((result) => {
			console.log("frontend message", result.data);
			if (result.data["message"] !== "") {
				console.log("yes");
				setTeacterText(result.data["message"]);
			} else {
				console.log("NO");
			}
		});
	}, []);

	useEffect(() => {
		return bindRecordingPageLifecycle({
			isBusy: () => recordingRef.current || isUploading,
			onLeave: () => {
				mountedRef.current = false;
				recordingAttemptRef.current++;
				recordingRef.current = false;
				clearInterval(tempTimeRef.current);
				previewTimersRef.current.forEach(timer => clearTimeout(timer));
				leaveSession();
			},
			onRestore: () => window.location.reload()
		});
	}, [isUploading]);


	useEffect(() => {
		fronLogger(token, readyState, "ok", "Client.js");
		if (readyState === IN_PROGRESS && stateProgress !== 'shureDevice') {
			let timer = setTimeout(function () {
				if (readyState === IN_PROGRESS) {
					setError(true);
				}
			}, 2 * 60 * 1000);
			return () => clearTimeout(timer);
		}
	}, [readyState, stateProgress, token]);

	useEffect(() => {
		let timer;
		if (isProcessing && processingTimeLeft > 0) {
			timer = setTimeout(() => {
				setProcessingTimeLeft(prevTime => prevTime - 1);
			}, 1000);
		} else if (isProcessing && processingTimeLeft === 0) {
			// Processing complete, show video player
			setIsProcessing(false);
			setShowPlayer(true);
		}
		return () => clearTimeout(timer);
	}, [isProcessing, processingTimeLeft]);

	function sleep(ms) {
		return new Promise((resolve) => {
			previewTimersRef.current.push(setTimeout(resolve, ms));
		});
	}

	const handleScreenVideoChange = async (event) => {
		if (event.target.files.length > 0) {
			const file = event.target.files[0];
			setScreenVideoFile(file);
			setScreenButtonText(file.name);
			const valid = await validateVideo(file);
		} else {
			setScreenVideoFile(null);
			setScreenButtonText("Выбрать видео экрана");
		}
	};

	const handleCameraVideoChange = async (event) => {
		if (event.target.files.length > 0) {
			const file = event.target.files[0];
			setCameraVideoFile(file);
			setCameraButtonText(file.name);
			const valid = await validateVideo(file);
		} else {
			setCameraVideoFile(null);
			setCameraButtonText("Выбрать видео камеры");
		}
	};

	const validateVideo = async (file) => {
		return true; 	// TODO
		/*new Promise((resolve) => {
			const video = document.createElement('video');
			video.preload = 'metadata';
			video.src = URL.createObjectURL(file);
			video.onloadedmetadata = () => {
				URL.revokeObjectURL(video.src);
				if (video.videoHeight >= 480) {
					resolve(true);
				} else {
					resolve(false);
				}
			};
			video.onerror = () => {
				URL.revokeObjectURL(video.src);
				resolve(false);
			};
		});*/
	};

	const handleSendVideos = async () => {

		if (isUploading) return;
		const allowedFormats = ['video/webm'];

		const lightValidateVideo = (file, name) => {
			if (!file) {
				alert(`Пожалуйста, выберите видео ${name}`);
				return false;
			}
			if (!allowedFormats.includes(file.type)) {
				alert(`Видео ${name} должно быть в формате WebM`);
				return false;
			}
			return true;
		};

		if (!lightValidateVideo(screenVideoFile, 'экрана')) return;

		if (!noCameraVideo) {
			if (!cameraVideoFile) {
				alert('Если у вас нет видео с камеры - поставьте соответствующую галочку.');
				return;
			}
			if (!lightValidateVideo(cameraVideoFile, 'камеры')) return;
			if (cameraVideoFile.name === screenVideoFile.name) {
				alert('Выбраны одинаковые файлы для видео экрана и камеры');
				return;
			}
		}

		// Проверка корректности и разрешения видео
		/*const screenValid = await validateVideo(screenVideoFile);
		if (!screenValid) {
			alert("Видео экрана повреждено или имеет разрешение ниже 480p");
			return;
		}
		const cameraValid = await validateVideo(cameraVideoFile);
		if (!cameraValid) {
			alert("Видео камеры повреждено или имеет разрешение ниже 480p");
			return;
		}*/

		setIsUploading(true);
		setUploadMessage("Передача файлов на сервер…");
		setUploadProgress(0);
		setUploadProgressIndeterminate(true);

		try {
            const status = (await axios.get(`${host}/upload/session/${token}/status`, { timeout: 120000 })).data;
            if (typeof status.videosSaved !== 'boolean' || typeof status.uploading !== 'boolean') throw new Error('Некорректный ответ статуса загрузки');
            if (status.videosSaved || status.uploading) {
                setFormButtonsDisabled(true);
                setDisableButton(true);
                setUploadMessage(status.videosSaved ? 'Видео уже сохранены. Повторная загрузка не требуется.' : 'Сервер ещё сохраняет видео. Повторно отправлять файлы не нужно; проверьте состояние позже.');
                return;
            }
			const formData = new FormData();
			formData.append("sessionId", token);
			formData.append("video_screen", screenVideoFile, screenVideoFile.name);
			if (!noCameraVideo)
				formData.append("video_webcam", cameraVideoFile, cameraVideoFile.name);
			formData.append("no_camera_video", noCameraVideo);
			formData.append("comment", commentText)
			const response = await axios.post(`${host}/upload/session`, formData, {
				timeout: 0,
				onUploadProgress: ({loaded, total}) => {
					if (!total) return;
					const percentCompleted = Math.min(100, Math.round((loaded * 100) / total));
					setUploadProgress(percentCompleted);
					setUploadProgressIndeterminate(percentCompleted === 100);
                        if (percentCompleted === 100) setUploadMessage('Файлы переданы. Сервер проверяет и сохраняет видео — дождитесь подтверждения.');
				},
			});

			if (response.data?.success !== true) throw new Error("Сервер не подтвердил загрузку видео");
			setFormButtonsDisabled(true);
			setDisableButton(true)
			setStateProgress("videoUploadingCompleted")
			setScreenVideoFile(null);
			setCameraVideoFile(null);
			setScreenButtonText("Видео экрана отправлено");
			setCameraButtonText(noCameraVideo ? "Видео камеры не требуется" : "Видео камеры отправлено");
			setUploadProgress(0);
			setUploadProgressIndeterminate(false);
			setShowPlayer(true);
			fronLogger(token, "Видео успешно загружены", "ok", "Client.js");
			alert("Запись успешно загружена")
        } catch (error) {
            let saved = error.response?.data?.videosSaved === true;
            let uploading = false;
            let checked = false;
            try {
                const status = (await axios.get(`${host}/upload/session/${token}/status`, { timeout: 120000 })).data;
                if (typeof status.videosSaved !== 'boolean' || typeof status.uploading !== 'boolean') throw new Error('Некорректный ответ статуса загрузки');
                saved = saved || status.videosSaved === true;
                uploading = status.uploading === true;
                checked = true;
            } catch { /* A missing response must never authorize a duplicate upload. */ }
            const messages = {
                400: 'Сервер отклонил файлы. Нужны непустые видео в формате WebM.',
                401: 'Войдите на сайт в этом профиле браузера.',
                403: 'Нет доступа к этой сессии.',
                409: 'Сессия уже началась или получила видео.',
                413: 'Размер файлов превышает допустимый предел.',
                502: 'Сервер временно недоступен.',
                504: 'Сервер не успел завершить сохранение.'
            };
            const message = saved ? 'Видео сохранены. Повторно загружать файлы не нужно. Если обработка не началась, обратитесь к преподавателю.' :
                uploading ? 'Сервер ещё сохраняет видео. Не отправляйте файлы повторно; обновите страницу позже для проверки состояния.' :
                !checked ? 'Не удалось проверить сохранение. Сохраните исходные файлы и проверьте состояние позже; повторная отправка пока заблокирована. После восстановления связи обновите страницу.' :
                (messages[error.response?.status] || 'Не удалось завершить загрузку на сервере.') + ' Видео не подтверждены как сохранённые. Исходные файлы оставьте на компьютере.';
            if (saved || uploading || !checked) {
                setFormButtonsDisabled(true);
                setDisableButton(true);
            }
            setUploadMessage(message);
            alert(message);
            fronLogger(token, `Ошибка загрузки видео: HTTP ${error.response?.status || 'нет ответа'}`, "error", "Client.js");
		} finally {
			setIsUploading(false);
			setUploadProgressIndeterminate(false);
		}
	};

	useEffect(() => {
		apiFetch(`${host}/users/` + token)
			.then((res) => res.json())
			.then(
				(result) => {
					fronLogger(token, result.status, "ok", "Client.js");
					if (result.status === "-") setDisableButton(false);
					else setDisableButton(true);

				},
				(err) => {
					setAlertText("Экзамен не был начат. Обратитесь к преподавателю.");
					playError();
					console.error(err);
					fronLogger(token, err, "error", "Client.js");
				}
			);
	}, []);

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			addNotification({
				title: "Внимание!",
				message: "Запись НЕ начата!",
				native: true,
			});
		}, 300000); // every 5 minutes
		return () => clearInterval(intervalRef.current);
	}, []);

	function playError() {
		const audio = new Audio(
			"https://www.pacdv.com/sounds/interface_sound_effects/sound1.mp3"
		);
		audio.play();
	}

	function prev_message_on_start() {
		let time = PREVIEW_DURATION;
		const timerId = setInterval(() => {
			console.log(`Подождите ${time} секунд, пока появится видео`)
			set_prev_message(`Подождите ${time} секунд, пока появится видео`);
			time--;
			if (time === 0) {
			  clearInterval(timerId);
			}
		  }, 1000);
		previewTimersRef.current.push(timerId);
		
	}

	function prev_message_on_play() {
		set_prev_message("Видео начало проигрываться");
	}

	function prev_message_on_end() {
		set_prev_message(
			"Видео проиграно и поставлено на паузу. Если вы увидели как на видео предпоказа корректно отобразились и ваш экран, и ваша вебкамера, а также корректно записался звук (громкость видео может быть на нуле по умолчанию) - можете приступать к выполнению экзамена. Если были ошибки с отображением - попросите указаний у преподавателя."
		);
	}

	async function startRecording() {
		let browser = Bowser.getParser(navigator.userAgent);
		fronLogger(
			token,
			"Browser for token " +
				token +
				" name: " +
				browser.getBrowser().name +
				", version: " +
				browser.getBrowser().version,
			"ok",
			"Client.js"
		);

		if (recordButton === "Начать запись") {
			fronLogger(token, "Пользовать нажал начать запись", "ok", "Client.js");
			let needStart = window.confirm(t("Уверены, что хотите начать запись?"));
			if (needStart) {
				const attempt = ++recordingAttemptRef.current;
				try {
					await apiFetch(`${host}/users/${token}?flag=START`, { method: 'POST' });
					recordingRef.current = true;
				} catch (error) {
					setAlertText('Не удалось начать сессию. Проверьте соединение и повторите попытку.');
					return;
				}
				fronLogger(
					token,
					"Пользовать уверен, что хочет начать запись",
					"ok",
					"Client.js"
				);
				setReadyState(START);
				setStateProgress("shureStart");

				setButtonName("Остановить");
				setColorButton("error");
				let userName = "user-" + token;
				setReadyState(IN_PROGRESS);

				//generate random timeout
				let min = 0;
				let max = 20;
				let timeout = Math.floor(Math.random() * (max - min + 1)) + min; //Generate random value from 0 to 20 inclusively
				fronLogger(
					token,
					"Установлен таймаут",
					timeout,
					" c",
					"ok",
					"Client.js"
				);
				sleep(timeout * 1000).then(async () => {
					if (!mountedRef.current || recordingAttemptRef.current !== attempt) return;
					await loadRTCConfiguration();
					if (!mountedRef.current || recordingAttemptRef.current !== attempt) return;
					setStateProgress("waitComplete");
					joinRoom(userName, token, "webcam", setReadyState, setStateProgress); // token is the same as roomname
					clearInterval(intervalRef.current);
					intervalRef.current = null;
				}).catch(error => {
					if (!mountedRef.current || recordingAttemptRef.current !== attempt) return;
					setError(true);
					setAlertText('Не удалось получить настройки медиасоединения. Проверьте TURN-сервис.');
					fronLogger(token, error.message, 'error', 'Client.js');
				});
			}
		} else {
			fronLogger(token, "Пользовать остановил запись", "ok", "Client.js");
			let needStop = window.confirm(
				t(
					"После нажатия OK начать новую сессию будет нельзя. Вы уверены, что хотите закончить?"
				)
			);
			if (needStop) {
				recordingAttemptRef.current++;
				recordingRef.current = false;
				fronLogger(
					token,
					"Пользовать уверен, что хочет остановить запись",
					"ok",
					"Client.js"
				);
				setButtonName("Начать запись");
				setStateProgress("complete");
				setColorButton("success");
				setDisableButton(true);
				setReadyState(FINISH);
        		clear_timer();
				apiFetch(`${host}/users/` + token + "?flag=FINISH", { method: "POST" })
					.then((res) => res.json())
					.then((result) => console.log(result))
					.catch((err) => {
						console.error(err);
						fronLogger(token, err, "error", "Client.js");
					});
				const finalized = await stopSession(token);
				if (!finalized.success) setAlertText('Не удалось подтвердить сохранение или запуск обработки. Обратитесь к преподавателю.');
			}
		}
	}
  
  async function clear_timer() {
		clearInterval(tempTimeRef.current);
	}

  function backendDatetoStrDate(date){
	return formatSessionDate(date);
  } 

  function set_start_time() {
		clearInterval(tempTimeRef.current);
		startTimeRef.current = serverStartTimeRef.current || Date.now();
		const clientTimerStart = Date.now();
		setNowTime('00:00:00');

		tempTimeRef.current = setInterval(() => {
			setNowTime(formatElapsedTime(Date.now() - clientTimerStart));
		}, 1000);
	}

	async function add_prev_window() {
		prev_message_on_start();

		console.log("In function add_prev_window");
		console.log(`sleep ${PREVIEW_DURATION} sec`);
		await new Promise((resolve) => {
			const timer = setTimeout(resolve, PREVIEW_DURATION * 1000);
			previewTimersRef.current.push(timer);
		});
		console.log("sleep ends");
		if (!mountedRef.current) return;

		// ширина блока с предпоказом скринкаста высчитывается пропорционально его высоте (оно не квадратное) - чтобы +- совпадали окна видео по высоте
		let w = 450;
		let h = w;
		let scrren_w = w * 1.26;

		var video_screen = document.createElement("video");
		var video_webcam = document.createElement("video");

		video_screen.src = "/api/links/window/" + token; // compose video link
		video_webcam.src = "/api/links/webcam/" + token; // compose video link

		video_screen.setAttribute("width", scrren_w.toString());
		video_screen.setAttribute("height", h.toString());

		video_webcam.setAttribute("width", w.toString());
		video_webcam.setAttribute("height", h.toString());

		console.log("Попытка вывсети экран по ссылке: ", video_screen.src);
		console.log("Попытка вывсети вебку по ссылке: ", video_webcam.src);

		video_screen.autoplay = true;
		video_webcam.autoplay = true;

			document.body.appendChild(video_screen);
			document.body.appendChild(video_webcam);
			previewNodesRef.current = [video_screen, video_webcam];
		prev_message_on_play();
		await new Promise((resolve) => {
			const timer = setTimeout(resolve, PREVIEW_DURATION * 1000);
			previewTimersRef.current.push(timer);
		});
		prev_message_on_end();
		video_screen.pause();
		video_webcam.pause();

		// расскомментировать этот блок, если хотим убирать окна предпоказа после окончания предпоказа
		// video_screen.remove()
		// video_webcam.remove()
	}

	const refreshPage = () => {
		setReadyState(FINISH);
		window.reloadExpected = true;
		window.location.reload();
	};

	useEffect(() => {
		if (!showError) return;
		playError();
		fronLogger(
			token,
			`Client showError: Долгое создание соединения`,
			"error",
			"Client.js"
		);
		alert("Проблема долгого соединения")
		setAlertText("Экзамен не был начат. Обратитесь к преподавателю.");

		apiFetch(`${host}/failed/sessions/` + token, { method: "POST" })
			.then((res) => res.json())
			.then((result) => console.log(result))
			.catch((err) => {
				playError();
				console.error(err);
				fronLogger(token, err, "error", "Client.js");
			});

		setButtonName("Начать запись");
		setColorButton("success");
		setReadyState(START);
		setDisableButton(false);
		setReadyState(FINISH);
		clearInterval(tempTimeRef.current);
		recordingAttemptRef.current++;
		recordingRef.current = false;
		stopSession(token, false);
	}, [showError, token]);
	const error = showError ? <AlertError showAlert={showError} /> : null;
	if (!sessionData){
		return "Loading session data..."
	}
	else return (
		<Box>
			<Box sx={{ margin: "20px 0px 0px 50px" }}>
				<NavStruct />
			</Box>
			<Box className="client_form" sx={{ bgcolor: "background.paper" }}>
				<Box sx={{ margin: "30px" }}>
					<Typography
						variant="h5"
						color={"text.primary"}
						sx={{ width: "52vw" }}
					>
						{t(alertText)}
					</Typography>
					{stateProgress === "videoUploadingCompleted" && <Alert severity="success" role="status" sx={{ my: 2, fontSize: "1.25rem" }}>Все видео успешно загружены. Можно закрыть страницу. Повторная отправка не требуется.</Alert>}
					{error}
					<Box
						sx={{
							display: "flex",
							flexWrap: "nowrap",
							alignItems: "center",
							justifyContent: "space-between",
							width: "51vw",
							marginTop: "30px",
						}}
					>
						{!noStartMsg &&
							<>
								<Typography variant="h6" color={"text.primary"}>
									{t("Начать запись")}
								</Typography>
								<Typography variant="h6" color={"text.primary"}>
									{t("Установка соединения")}
								</Typography>
								<Typography variant="h6" color={"text.primary"}>
									{t("Разрешения")}
								</Typography>
								<Typography variant="h6" color={"text.primary"}>
									{t("Состояние предпоказа")}
								</Typography>
							</>
						}
					</Box>
					{!noStartMsg &&
						<>
							<Box sx={{ margin: "20px 0px 20px 30px" }}>
								<LinearProgress
									variant="determinate"
									value={progress}
									color={"primary"}
									sx={{
										width: "47vw",
									}}
								/>
							</Box>
							<Button
								color={colorButton}
								variant="contained"
								className="client_accept"
								onClick={() => startRecording()}
								disabled={disabledButton}
							>
								{t(recordButton)}
							</Button>
						</>
					}
				</Box>
			</Box>

			{showUploadForm && <VideoUploadForm
				disabledButton={disabledButton}
				formButtonsDisabled={formButtonsDisabled}
				isUploading={isUploading}
				isProcessing={isProcessing}
				screenVideoFile={screenVideoFile}
				cameraVideoFile={cameraVideoFile}
				uploadSuccess={uploadSuccess}
				screenButtonText={screenButtonText}
				cameraButtonText={cameraButtonText}
				uploadMessage={uploadMessage}
				uploadProgress={uploadProgress}
				uploadProgressIndeterminate={uploadProgressIndeterminate}
				processingTimeLeft={processingTimeLeft}
				handleScreenVideoChange={handleScreenVideoChange}
				handleCameraVideoChange={handleCameraVideoChange}
				handleSendVideos={handleSendVideos}
				setCommentText={setCommentText}
				noCameraVideo={noCameraVideo}
				setNoCameraVideo={setNoCameraVideo}
				setCameraVideoFile={setCameraVideoFile}
			/>
			}

			{showPlayer && (
				<Box sx={{ position: "fixed", top: 200, right: 50, bgcolor: "background.paper", p: 2, borderRadius: 2, boxShadow: 3, display: "flex", flexDirection: "column", gap: 2, width: 950 }}>
					<Typography variant="h6" sx={{ fontWeight: 'bold' }}>
						{t("Видео сессии. Проверьте их корректность")}
					</Typography>
					<Box sx={{ display: "flex", gap: 2, alignItems: 'flex-start' }}>
						<Box>
							<Typography variant="body1">{t("Видео экрана")}</Typography>
							<video
								src={`/api/links/window/${token}`}
								controls
								width="450"
								height="450"
								style={{ borderRadius: 4 }}
							/>
						</Box>
						<Box>
							<Typography variant="body1">{t("Видео камеры")}</Typography>
							<video
								src={`/api/links/webcam/${token}`}
								controls
								width="450"
								height="450"
								style={{ borderRadius: 4 }}
							/>
						</Box>
					</Box>
					<Button
						variant="outlined"
						onClick={() => setShowPlayer(false)}
						sx={{ alignSelf: "center" }}
					>
						{t("Скрыть плеер")}
					</Button>
				</Box>
			)}

			{!teacherText ? "" : <Box className="client_message" sx={{ bgcolor: "background.paper" }}>
				<Box sx={{ padding: "10px 30px 10px 30px" }}>
					<Typography sx={{ width: "52vw" }}>
						{t("Сообщение от преподавателя:")} {teacherText}
					</Typography>
				</Box>
			</Box>}
			{!noStartMsg &&
				<Box className="preview_info" sx={{ bgcolor: "background.paper" }}>
					<Box sx={{ padding: "10px 30px 10px 30px" }}>
						<Typography sx={{ width: "52vw" }}>
							{t("Состояние предпоказа: ")}
							{prev_message}
						</Typography>
					</Box>
				</Box>
			}

			<Box className="record_timer" sx={{ bgcolor: "background.paper" }}>
				<Box sx={{ padding: "10px 30px 10px 30px" }}>
					<Typography sx={{ width: "52vw" }}>
						{t("ФИО: ")} {sessionData['full_name']}
					</Typography>
				</Box>
				<Box sx={{ padding: "10px 30px 10px 30px" }}>
					<Typography sx={{ width: "52vw" }}>
						{t(" Группа: ")} {sessionData['group']}
					</Typography>
				</Box>
				<Box sx={{ padding: "10px 30px 10px 30px" }}>
					<Typography sx={{ width: "52vw" }}>
						{t(" Название работы: ")} {sessionData['title']}
					</Typography>
				</Box>
				{noStartMsg ?
					<>
						{sessionData.isUploaded ? 
							<Box sx={{ padding: "10px 30px 10px 30px" }}>
								<Typography sx={{ width: "52vw" }}>
									{t("Время загрузки")}{": "} {backendDatetoStrDate(sessionData.startTime)}
								</Typography>
							</Box>
							:
							<Box sx={{ padding: "10px 30px 10px 30px" }}>
								<Typography sx={{ width: "52vw" }}>
									{t("Время начала")}{": "} {backendDatetoStrDate(sessionData.startTime)}
								</Typography>
								<Typography sx={{ width: "52vw" }}>
									{t("Время завершения")}{": "} {backendDatetoStrDate(sessionData.endTime)}
								</Typography>
							</Box>
						}
					</>
					: <>
						<Box sx={{ padding: "10px 30px 10px 30px" }}>
							<Typography sx={{ width: "52vw" }}>
								{t("Время начала")}{": "}
								{startTimeRef.current ? backendDatetoStrDate(startTimeRef.current) : '—'}
							</Typography>
						</Box>
						<Box sx={{ padding: "10px 30px 10px 30px" }}>
							<Typography sx={{ width: "52vw" }}>
								{t("Записалось (в формате h:m:s): ")} {nowTime}
							</Typography>
						</Box>
					</>
				}
			</Box>  
		</Box>
	);
}
